<template>
<div>

    <div
        v-for="(item, index) in incidents"
        :key="index"
    >
        <v-banner
            
            v-if="showBanner(item)"

            :style="incidentSytle(item)"
            sticky
            transition="slide-y-transition"
            single-line
        >

            {{bannerText(item)}}

            <template v-slot:actions="{ dismiss }">
                <v-btn
                    text
                    v-on:click="onClickDetails(item)"
                >
                Details
                </v-btn>
                <v-btn
                    text
                    v-on:click="onClickDismiss(item, dismiss)"
                >
                Dismiss
                </v-btn>
            </template>
        </v-banner>
    </div>

    <m-incident-detail-dialog
        ref="detail-dialog"
    />

</div>
</template>

<script>
export default 
{
    props: {
        page: {
            type: String,
            default: function() { return "home"; }
        },
    },    

    data() {
        return {
            incidents: [],
            last_update_time: 0,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update()
        {
            if ( Date.now() - this.last_update_time < 60000 )
            {
                // To limit server load we only check for a resolution once per minute
                return;
            }

            this.last_update_time = Date.now();

            this.$rc.rest(
                'LIST: /api/v1/incidents/active',
            
                {
                },
            
                (data) => {
                    this.incidents = data.results;

                    // Set the has seen key for all incidents
                    for ( let i = 0; i < this.incidents.length; i++ )
                    {
                        if ( this.incidents[i].state == 'open' )
                            window.localStorage.setItem(this.keySeen(this.incidents[i]), true);
                    }
                },
            
                () => {
                },
            );
        },

        incidentSytle(item) 
        {
            if ( item.state == 'resolved' )
                return "background-color: #dcffdc; padding-top: 5px;";
            
            return "background-color: #ffdcdc; padding-top: 5px;";
        },

        bannerText(item)
        {
            if ( this.page == 'home' && item.state == 'open' ) return item.open_text_home_page;
            if ( this.page == 'home' && item.state == 'resolved' ) return item.resolved_text_home_page;
            if ( this.page == 'bulk_message' && item.state == 'open' ) return item.open_text_bulk_message;
            if ( this.page == 'bulk_message' && item.state == 'resolved' ) return item.resolved_text_bulk_message;

            return '';
        },

        onClickDetails(item)
        {
            this.$refs['detail-dialog'].showDialog(item.incident_id);
        },

        keySeen(item)
        {
            return 'incident-seen-'+item.incident_id;
        },

        keyDismissed(item)
        {
            return 'incident-dismissed-'+item.incident_id+'-'+item.state;
        },

        onClickDismiss(item, dismiss)
        {
            window.localStorage.setItem(this.keyDismissed(item), true);

            dismiss();
        },

        showBanner(item)
        {
            if ( window.localStorage.getItem(this.keyDismissed(item)) != null )
            {
                return false;
            }

            if ( item.state == 'resolved' && window.localStorage.getItem(this.keySeen(item)) == null )
            {
                // resolved and the user never saw the banner...
                return false;
            }

            if ( this.page == 'home' && !item.show_banner_home_page )
            {
                return false;
            }

            if ( this.page == 'bulk_message' && !item.show_banner_bulk_message )
            {
                return false;
            }

            return true;
        },

        isAnyBannerVisible()
        {   
            for ( let i = 0; i < this.incidents.length; i++ )
            {
                if ( this.showBanner(this.incidents[i]) )
                    return true;
            }
            return false;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>

<!--
final private UUID incident_id;
	final private IncidentState state;
	final private long creation_time;
	final private Optional<Long> resolution_time;
	final private boolean show_banner_home_page;
	final private boolean show_banner_bulk_message;
	final private String open_text_home_page;
	final private String open_text_bulk_message;
	final private String resolved_text_home_page;
	final private String resolved_text_bulk_message;
	final private String details_markdown; -->